<template>
    <BaseTooltip
        data-spec-class="tooltip-help"
        :theme="theme"
        @update="onUpdate"
    >
        <template #trigger>
            <component
                :is="icon"
                :class="{
                    'text-gray-400 hover:text-gray-300': theme === Theme.Dark,
                    '!text-gray-300': theme === Theme.Dark && isActive,
                    'text-gray-500 hover:text-gray-400': theme === Theme.Light,
                    '!text-gray-400': theme === Theme.Light && isActive,
                    'size-7': size === Size.Large,
                    'size-5': size === Size.Normal,
                }"
            />
        </template>
        <slot> </slot>
    </BaseTooltip>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Component } from 'vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline';
import { Size, Theme } from '@/types';
import BaseTooltip from './BaseTooltip.vue';

interface Props {
    size?: Size;
    theme?: Theme;
    icon?: Component;
}

withDefaults(defineProps<Props>(), {
    size: Size.Normal,
    theme: Theme.Dark,
    icon: () => QuestionMarkCircleIcon,
});

const isActive = ref(false);

const onUpdate = (updatedIsActive: boolean) => {
    isActive.value = updatedIsActive;
};
</script>
